<template>
  <div class="panel__content__element">
    <div class="g-handle" />
    <accordion-element-component
      class="g-grey-box"
      v-bind="{Data: {icon: ['custom', 'station'], title: $t('messages.flow.title'), subTitle: computedFlowTitle}}"
    >
      <flow-gauge-component :store = "store" />
    </accordion-element-component>
  </div>
</template>

<script>
import {UnitSystem} from '@/assets/javascript/mixins/Mixins'
import AccordionElement from '@/components/elements/AccordionElement'
import FlowGauge from '@/components/FlowGauge.vue'

export default
{
  name: 'AccordionFlow',
  components:
  {
    'flow-gauge-component': FlowGauge,
    'accordion-element-component': AccordionElement,
  },
  mixins: [UnitSystem],
  props: {
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedRunningStations() {
      let stations = []
      let faulted = 0
      let running = 0

      this.store.getData('stations').forEach(station => {
        if(station.status === '1') {
          stations.push(station)
          faulted += 1
        } else if(station.isRunning) {
          stations.push(station)
          running += 1
        }
      })
      return {stations, faulted, running}
    },
    computedFlowTitle() {
      // console.log('store: ' + JSON.stringify(this.store.data.controller.group))

      const flow = this.store.getData('currentFlow')
      const capacity = this.store.getData('systemCapacity')
      const expected = this.store.getData('expectedFlow')
      const waterUnit =  this.getDenominator('litre', 'gallon', 0) + '/' + this.$tc('messages.sharedTexts.time.m', 1)
      const buffer =  expected * 0.1

      const states = {
        unscheduled: {
          text: this.$t('messages.flow.unscheduled'),
          title: this.$t('messages.flow.unscheduledFlow'),
          class: 'red'
        },
        deviation: {
          text: this.$t('messages.flow.deviation'),
          title: this.$t('messages.flow.deviationFlow'),
          class: 'red'
        },
        normal: {
          text: this.$t('messages.flow.normal'),
          title: this.$t('messages.flow.normalFlow'),
          class: 'green'
        } 
      }

      let state = {}

      if(this.computedRunningStations.running === 0 && flow !== 0) {
        state = states.deviation
      } else {
        state = flow >= expected - buffer && flow <= expected + buffer
        ? states.normal
        : states.unscheduled
      }
      // console.log('systemCapacity is: ' + capacity )

      return `${this.convertUnits(flow ? flow : 0, 'gal/min', 'l/min').toFixed(0)} ${this.$t('messages.flow.of')} ${this.convertUnits(capacity ? capacity: 0, 'gal/min', 'l/min').toFixed(0)} ${waterUnit}&nbsp;<span title="${state.title}" class="${state.class}">${state.text}</span>`
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
